export function getCountryCodeFromLocale(locale: string) {
  return locale.split('-')[1]
}

type TimeZoneInfo = {
  name: string
  prettyName: string
  offset: number
}

/**
 * Gets a list of all supported timezones along with their offset
 * @returns list of TimeZoneInfo objects which hold the timezone name, a pretty display name and the values of the timezone's offset
 */
export function getTimeZoneInfo(): TimeZoneInfo[] {
  const supportedTimeZones = Intl.supportedValuesOf('timeZone')

  const timezoneInfo = supportedTimeZones.map((tz) => {
    const offsetFormat = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      timeZoneName: 'longOffset',
    })

    const formattedOffset = offsetFormat.format(new Date())
    const [_, offsetString] = formattedOffset.split(', ')

    const offsetNumeric = offsetStringToNumeric(offsetString)
    return {
      name: tz,
      prettyName: `${tz} (${offsetString})`.replaceAll('_', ' '),
      offset: offsetNumeric,
    } as TimeZoneInfo
  })

  // add extra timezone
  timezoneInfo.push({
    name: 'UTC',
    prettyName: 'UTC',
    offset: 0, // not used
  })

  // sort by offset
  return timezoneInfo.sort(function (a, b) {
    return a.offset - b.offset
  })
}

function offsetStringToNumeric(offsetString: string): number {
  const sign = offsetString.startsWith('GMT-') ? -1 : 1
  const [hours, minutes] = offsetString.slice(4).split(':').map(Number)
  return sign * (hours * 60 + minutes) || 0
}
